export const salesFlow = {
  loading: 'Vennligst vent',
  confirmationHome: 'Tilbake til forsiden',
  confirmationPaidTodayTemplate: '$price$ betalt i dag',
  confirmationPriceAfterCampaignTemplate: 'Deretter $price$',
  confirmationReceipt: 'Kvittering er sendt til e-posten din',
  confirmationTitle: 'Medlemskapet er klart',
  confirmationWelcome: 'Velkommen til Fresh Fitness.',
  campaignEndDate: 'ut $date$',
  downloadAppButton: 'Last ned app',
  subscriptionPriceAfterCampaign: 'Deretter $price$',
  subscriptionOriginalPrice: 'Orginalt $price',
  membershipInformationAgeRestrictionBinding:
    'Under 18 år? Velg uten binding – bindingstid er kun tilgjengelig fra fylte 18 år.',
  membershipInformationNoticePeriod:
    'Alminnelig oppsigelsestid gjelder ved medlemskap uten binding.',
  allClubs: 'Alle sentre',
  clubSizeTemplate: '$size$ kvm',
  clubCount: '$clubCount$ sentre',
  stepProgressTemplate: 'Steg $currentStep$ av $totalSteps$',
  aboutYou: 'Om deg',
  selectClub: 'Bli medlem',
  selectMembership: 'Medlemskap',
  selectPaymentMethod: 'Velg betalingsmetode',
  membershipDiscountQuestion: 'Har du en rabattkode?',
  campaignCountdownPrefix: 'SLUTTER OM',
  payment: 'Betaling',
  paymentSummaryCampaignDisclaimer: 'etter kampanjen',
  paymentSummaryCollapseLabel: 'Skjul betalingsoversikt',
  paymentSummaryExpandLabel: 'Vis betalingsoversikt',
  paymentSummaryPayTodayLabel: 'Å betale nå',
  openingHoursTemplate: 'Åpent $from$–$to$',
  regionFilterLabel: 'Filtrer etter region',
  regionFilterAllClubs: 'Alle',
  locationSearchPlaceholder: 'Søk med postnummer',
  locationSearchButton: 'Søk',
  nearestMeLabel: 'Finn sentre nær meg',
  nearestResultsTemplate: 'Nærmest $location$',
  nearestYou: 'deg',
  basedOnPosition: 'Basert på posisjonen din',
  noClubsWithinRange: 'Det finnes ingen sentre i nærheten av ditt søk',
  yourInformation: 'Dine opplysninger',
} as const;
